<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-12 col-lg-12">

      <div class="row pb">
        <div class="col-12 form-field">
          <p-floatlabel variant="on">
            <input style="width: 100%" type="text" pInputText formControlName="name" id="name" [maxlength]='MAXIMUM_DEFAULT_STRING_INPUT_LENGTH'
                   formInlineError="personManagement.input.error" wellInputTrim data-testid="name-input"/>
            <label for="name">{{'personManagement.input.name' | translate}} *</label>
          </p-floatlabel>
        </div>
      </div>

      <div class="row pb" *ngIf="!showOnlyName">
        <div class="col-12 form-field">
          <p-floatlabel variant="on">
            <input style="width: 100%" type="text" pInputText formControlName="address" id="address" wellInputTrim
                   [maxlength]='MAXIMUM_DEFAULT_STRING_INPUT_LENGTH' data-testid="address-input"/>
            <label for="address">{{'personManagement.input.address' | translate}}</label>
          </p-floatlabel>
        </div>
      </div>

      <div class="row pb" *ngIf="!showOnlyName">
        <div class="col-12 form-field">
          <p-floatlabel variant="on">
            <input style="width: 100%" type="text" pInputText formControlName="county" id="county"
                   [maxlength]='MAXIMUM_DEFAULT_STRING_INPUT_LENGTH'
                   formInlineError="personManagement.input.error" wellInputTrim data-testid="county-input"/>
            <label for="county">{{'personManagement.input.county' | translate}}</label>
          </p-floatlabel>
        </div>
      </div>

      <div class="row pb">
        <div class="col-12 form-field">
            <p-floatlabel variant="on">
              <well-country-dropdown
                id="country"
                formControlName="country"
                formInlineError="legalEntity.error" data-testid="country-dropdown"/>
              <label for="country">{{'personManagement.input.country' | translate}}</label>
            </p-floatlabel>
        </div>
      </div>

    </div>
  </div>
</form>


